/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fold': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M911.2 668H400.8c-24.8 0-44.8-21.6-44.8-48s20-48 44.8-48h510.4c24.8 0 44.8 21.6 44.8 48s-20 48-44.8 48zm0-224H400.8c-24.8 0-44.8-21.6-44.8-48s20-48 44.8-48h510.4c24.8 0 44.8 21.6 44.8 48s-20 48-44.8 48zM908 228H126.4c-26.4 0-49.6-20-50.4-46.4-.8-27.2 20.8-49.6 48-49.6h781.6c26.4 0 49.6 20 50.4 46.4.8 27.2-20.8 49.6-48 49.6zM76 667.2V348.8L299.2 508 76 667.2c0 .8 0 .8 0 0zM124 788h781.6c26.4 0 49.6 20 50.4 46.4.8 27.2-20.8 49.6-48 49.6H126.4c-26.4 0-49.6-20-50.4-46.4-.8-27.2 20.8-49.6 48-49.6z"/>'
  }
})
